import { createRouter } from '@tanstack/react-router';

import { RouteErrorBoundary } from '~/components/common/error-boundary/route-error-boundary';
import { routeTree } from '~/routeTree.gen';

// Single TanStack Router instance for the app; centralised here so the
// `Register` module declaration below provides global type inference for
// every `useNavigate`, `Link`, and route-aware hook in the codebase.
export const router = createRouter({
  routeTree,
  defaultErrorComponent: RouteErrorBoundary,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
